
import ReviewsSkeletonTabSectionTopContent from './TabSection/TopContent.vue';
import ReviewsSkeletonTabSectionMainContent from './TabSection/MainContent.vue';

export default {
  name: 'ReviewsSkeletonTabSection',
  components: {
    ReviewsSkeletonTabSectionTopContent,
    ReviewsSkeletonTabSectionMainContent,
  },
  data() {
    return {};
  },
};
